<template>
  <div id="about">
    <div class="general-header container">
      <h3 class="cate-title">关于盈能</h3>
      <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item >关于盈能</el-breadcrumb-item>
            </el-breadcrumb>
    </div>
    <div class="about container">
      <img src="../../assets/images/about.png" class="main-banner" alt="">
      <p class="title-wrapper">企业简介</p>
      <div class="about-content">
        &nbsp;&nbsp;&nbsp;&nbsp;
        常州盈能电气有限公司（下面简称：盈能电气）始创于2008年1月，位于江苏省常州市。是一家专业从事生产销售电气设备、工业机器人、监控设备、电力配套设备的公司。主要产品有：轮式巡检机器人，轨道式巡检机器人等。
      </div>
      <div class="about-content">
        盈能电气始终坚持“可靠、经济、清洁、互动”的智能电网建设目标，借助建设坚强智能电网，成为客户首选的智能电网配套供应商。竭诚与国内外商家双赢合作，互惠发展，共创辉煌！
      </div>
      <p class="title-wrapper-s">科创</p>
      <div class="about-content">
        2008年，盈能电气通过“GB/T19001-2008质量管理体系认证”（中联认证中心）<br>
        2010年，盈能电气获得“科技型中小企业技术创新基金”立项（科学技术部）<br>
        2011年，盈能电气被认定为“高新技术企业”（江苏省科学技术厅）<br>
        2014年，无源无线触头测温纳入国家“火炬计划”（国家科学技术部）<br>
        2016年，盈能电气深化“让设备拥有坚强保护”使命，进一步升级产品，将原有产品全部迁移到以物联网为基础的数据平台，不仅可以让客户可以足不出户，就可以掌握现场设备环境数据，让客户更安心；而且改造过程非常方便，能够快速迁移，能够以较小的代价实现物联，给客户良好体验。
      </div>
      <div class="about-content">
        盈能始终将根据客户需求创新作为公司运营核心，通过产品创新，管理创新，来更好的服务于客户。<br>
        截止目前，公司共申请专利106项是江苏知识产权示范企业。
      </div>
      <p class="title-wrapper-s">我们的愿景</p>
      <div class="about-content">
        突破极限，追寻光明
      </div>
      <p class="title-wrapper-s">我们的使命</p>
      <div class="about-content">
        让设备拥有坚强保护
      </div>
      <p class="title-wrapper-s">我们的价值观</p>
      <div class="about-content">
        客户至上——为客户提供满意的产品和服务<br>
        以人为本——为员工提供良好的工作环境、待遇和发展机会<br>
        诚实奋进——诚实的为人准则，积极，敢争的人生态度<br>
        勇于创新——在产品、工作、生活中融入更多智慧，提供更高 质量<br>
        结果导向——迅速行动，重在结果<br>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "about"
    }
</script>

<style scoped lang="less">
  #about{
    .general-header{
      border-bottom: 1px solid #dddddd;
      padding: 31px 0;
      .cate-title{
        display: inline-block;
        width: 190px;
        margin:0;

      }
      .el-breadcrumb{
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .about{
      padding: 20px;
      .main-banner{
        width: 100%;
        margin-bottom: 30px;
      }
      .title-wrapper{
        font-size: 18px;
        margin-bottom: 16px;
      }
      .title-wrapper-s{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
      }
      .about-content{
        line-height: 24px;
        margin-bottom: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/about.vue